import { withCompInfo } from '../../core/withCompInfo'
import { TextInputDefinition, TextInputProps, TextInputCSSVars, TextInputCssCarmiData } from './types'
import { getInputHeightInPx, getLabelPadding, getRequiredIndicationDisplay } from '../../core/inputUtils'

export const props = withCompInfo<TextInputProps, TextInputDefinition>(
	['compData', 'compProps', 'skin', 'styleProperties'],
	({ compData, compProps, skin }) => ({
		skin: skin === 'ResponsiveTextInputSkin' ? 'ResponsiveTextInputSkin' : 'AppsTextInputSkin',
		value: compData.value || '',
		inputType: compData.textType,
		label: compData.label,
		placeholder: compData.placeholder || compProps.placeholder,
		readOnly: compProps.readOnly || false,
		required: compProps.required,
		autoComplete: compData.textType !== 'password' && compProps.autoComplete,
		autoComplete_: compData.textType !== 'password' && compProps.autoComplete ? 'on' : null,
		isDisabled: compProps.isDisabled || false,
		pattern: compData.pattern,
		maxLength: compData.maxLength,
		...(compData.textType === 'number' && { min: compData.min, max: compData.max, step: compData.step }),
	})
)

const getTextPaddingCssVar = (
	alignment: TextInputDefinition['property']['textAlignment'],
	textPadding: TextInputDefinition['property']['textPadding']
): string | undefined => {
	const padding = textPadding === undefined ? 3 : textPadding
	switch (alignment) {
		case 'left':
			return `3px 3px 3px ${padding}px`
		case 'right':
			return `3px ${padding}px 3px 3px`
		default:
			return `3px`
	}
}

export const css = withCompInfo<TextInputCSSVars, TextInputDefinition, TextInputCssCarmiData>(
	['compLayout', 'compProps', 'styleProperties', 'isMobileView', 'hasResponsiveLayout'],
	({ compLayout, compProps, styleProperties, isMobileView, hasResponsiveLayout }, cssVars) => {
		const { textAlignment, textPadding, labelMargin } = compProps

		const sharedProps = {
			...cssVars,
			'--dir': (textAlignment === 'right' ? 'rtl' : 'ltr') as 'ltr' | 'rtl',
			'--textAlign': textAlignment,
			'--textPadding': getTextPaddingCssVar(textAlignment, textPadding),
		}

		if (hasResponsiveLayout) {
			return sharedProps
		} else {
			return {
				...sharedProps,
				height: 'auto',
				'--labelMarginBottom': `${labelMargin}px`,
				'--inputHeight': getInputHeightInPx({ compProps, compLayout, isMobileView }),
				'--labelPadding': getLabelPadding(compProps),
				'--requiredIndicationDisplay': getRequiredIndicationDisplay(styleProperties),
			}
		}
	}
)
